<template>
  <v-card v-if="getCobranza" :loading="loading" flat>

    <v-card-text class="pa-0" v-if="enableDetails">
      <v-card outlined>
        <v-card-title v-if="title">{{title}}</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-list>
                <show-field
                    v-if="canView('_id')"
                    :value="getCobranza.id"
                    label="ID"
                    icon="contact_page"
                />
                <show-field
                    v-if="canView('dniDeudor')"
                    :value="getCobranza.dniDeudor"
                    :label="$t('cobrox.cobranza.labels.dniDeudor')"
                    icon="badge"
                />
                <show-field
                    v-if="canView('cuilDeudor')"
                    :value="getCobranza.cuilDeudor"
                    :label="$t('cobrox.cobranza.labels.cuilDeudor')"
                    icon="contact_page"
                />






              </v-list>
            </v-col>



            <v-col cols="12" sm="4">
              <v-list>
                <show-field
                    v-if="canView('agencia')"
                    :value="getCobranza.agencia ? getCobranza.agencia.nombre : ''"
                    :label="$t('cobrox.cobranza.labels.agencia')"
                    icon="business"
                />

                <show-field
                    v-if="canView('estado')"
                    :value="getCobranza.estado"
                    :label="$t('cobrox.cobranza.labels.estado')"
                    icon="toc"
                />

                <v-list-item  v-if="canView('montoCobrado')" :class="highlightMontoCobrado ? 'yellow lighten-3' : ''">
                  <v-list-item-icon class="mr-5">
                    <v-icon color="primary">payments</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content class="mr-0">
                    <v-list-item-title >${{getCobranza.montoCobrado.toLocaleString('es-AR')}}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('cobrox.cobranza.labels.montoCobrado') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>


              </v-list>

            </v-col>

            <v-col cols="12" sm="4">
              <v-list>
                <show-field
                    v-if="canView('createdAt')"
                    :value="getDateFormat(getCobranza.createdAt)"
                    :label="$t('cobrox.cobranza.labels.fechaCreacion')"
                    icon="today"
                />

                <show-field
                    v-if="canView('fechaCobranza')"
                    :value="getDateFormat(getCobranza.fechaCobranza)"
                    :label="$t('cobrox.cobranza.labels.fechaCobranza')"
                    icon="event"
                />
                <show-field
                    v-if="canView('fechaImputacion')"
                    :value="getDateFormat(getCobranza.fechaImputacion)"
                    :label="$t('cobrox.cobranza.labels.fechaImputacion')"
                    icon="event_available"
                />

              </v-list>
            </v-col>


          </v-row>
        </v-card-text>

      </v-card>

    </v-card-text>

  </v-card>

</template>

<script>
import {DayjsMixin} from "@dracul/dayjs-frontend";
import {ShowField} from "@dracul/common-frontend";
import CobranzaCustomProvider from "@/modules/cobrox/providers/CobranzaCustomProvider";
import SuretyMixin from "@/modules/surety/mixins/SuretyMixin";

export default {
  name: "CobranzaDetailMini",
  props: {
    cobranzaId: String,
    cobranza: Object,
    enableDetails: {type: Boolean, default: true},
    enableFacturas: {type: Boolean, default: true},
    highlightMontoCobrado: {type: Boolean, default: false},
    title: {type: String, default: null},
  },
  mixins: [DayjsMixin, SuretyMixin],
  components: { ShowField},
  data() {
    return {
      cobranzaLocal: null,
      loading: false
    }
  },
  created() {
    this.fetchFieldPermission('Cobranza')
    if (this.cobranzaId) {
      this.fetchCobranza()
    }
  },
  computed: {
    getCobranza() {
      if (this.cobranzaId) {
        return this.cobranzaLocal
      } else {
        return this.cobranza
      }
    },
    getFacturasDeudor() {
      return (this.getCobranza.facturas.length > 0) ? this.getCobranza.facturas.filter(f => f.cobranza.dniDeudor === f.deuda.dniDeudor) : []
    },
    getFacturasExtra() {
      return (this.getCobranza.facturas.length > 0) ? this.getCobranza.facturas.filter(f => f.cobranza.dniDeudor != f.deuda.dniDeudor) : []
    }
  },
  methods: {
    fetchCobranza() {
      this.loading = true
      CobranzaCustomProvider.findCobranzaPopulated(this.cobranzaId)
          .then(res => {
            this.cobranzaLocal = res.data.cobranzaFindPopulated
          })
          .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>
